import api from './api';

export const lecturesAPI = {
  getLecturesById: (teacherId) => api.get(`/lectures/get-lectures/${teacherId}`),
  getLectureById: (lectureId) => api.get(`/lectures/get-lecture/${lectureId}`),
  uploadLecture: (data) => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('teacherId', data.teacherId);
    if (data.lectureFile) formData.append('lectureFile', data.lectureFile);
    if (data.thumbnail) formData.append('thumbnail', data.thumbnail);
    
    return api.post('/lectures/upload-lecture', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000
    });
  },
  deleteLecture: (lectureId) => api.delete(`/lectures/delete-lecture/${lectureId}`),
};
 